import React from 'react';

function Home() {
  return (
    <div className="home-container">
      <h2>Accidental Poet</h2>
      
      <div className="home-description">
        <p>
        I don't know if poetry and I go together. Modern poetry's home is ethereal, delicate, raw, chaotic.  It's a bit like a tornado that's gone through a tulip patch. It's full of beauty and a bit terrifying and every once in a while it hits you. 
        </p>
        <p>
        On this website you will find my attempt to surrender myself into this vortex. By bringing my own energy to this I've expanded the vortex a bit so I can fit. To the delight of many and the rage of some, I've written a number of interactive poems. They are about your experience with the words.
        </p>
        <p>
        I hope they grab you, and lift you up and spit you out somewhere new.
        </p>
        <p>
          Now go play!
        -Marie
        </p>
      </div>
      
      <style jsx>{`
        .home-container {
          animation: fadeIn 0.8s cubic-bezier(0.19, 1, 0.22, 1);
          padding: 40px 0;
        }
        
        .subtitle {
          margin-bottom: 40px;
          color: #605e5c;
          font-weight: 300;
          font-size: 0.95rem;
          letter-spacing: 0.5px;
        }
        
        .home-description {
          max-width: 600px;
          margin: 0 auto;
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.2rem;
          line-height: 1.8;
          color: #3c3c3c;
        }
        
        .home-description p {
          margin-bottom: 1.4em;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default Home;